import { useState, useEffect } from 'react';

type PaginatedList<T> = {
  pagination?: {
    page?: number,
    totalCount?: number,
    totalPages?: number,
    nextPage?: number | null,
    previousPage?: number | null,
  },
  items?: Array<T>,
};

export const usePaginatedPagination = <T extends object>(data?: PaginatedList<T>) => {
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [displayItems, setDisplayItems] = useState<T[]>([]);

  useEffect(() => {
    if (!data) return;
    const { pagination, items } = data;
    setTotalPages(pagination?.totalPages ?? 1);
    setPage(pagination?.page ?? 1);
    setTotalCount(pagination?.totalCount ?? 0);
    setDisplayItems(items ?? []);
  }, [data]);

  return {
    totalPages,
    totalCount,
    page,
    displayItems,
  };
};
